import { render } from "./LayoutMobileNavbarComponent.vue?vue&type=template&id=08cad78c&scoped=true"
import script from "./LayoutMobileNavbarComponent.vue?vue&type=script&lang=js"
export * from "./LayoutMobileNavbarComponent.vue?vue&type=script&lang=js"

import "./LayoutMobileNavbarComponent.vue?vue&type=style&index=0&id=08cad78c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\epentilescu\\source\\repos\\Delicitate V2\\front-end\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08cad78c"]])

export default __exports__